const theme = {
  id: "light",
  primaryColor: "#00ADB5",
  secondaryColor: "#222831",
  bodyBackgroundColor: "#EEEEEE",
  bodyFontColor: "#393E46",
};

export default theme;

